import { Tag as AntTag } from "antd";
import type { TagProps as AntTagProps } from "antd";

export interface TagProps extends AntTagProps {
  children?: React.ReactNode;
}

export function Tag({ children, ...props }: TagProps) {
  return <AntTag {...props}>{children}</AntTag>;
}
